namespace AgerLMS.LMS {
    export interface CheckCouponCodeRequest extends Serenity.ServiceRequest {
        CouponCode?: string;
        DiscountId?: number;
    }
}
